import { Skeleton } from '@mui/material';
import _isNil from 'lodash/isNil';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import UserApi from '@Data/users/Api';
import { userState } from '@Data/users/Reducer';
import { IUserAvatarButtonProps } from './Interfaces';
import Styles from './UserAvatarButton.scss';
import { IconButton, UserAvatarButtonSize } from './index';

const UserAvatarButton = (props: IUserAvatarButtonProps) => {
    const {
        tooltip,
        id,
        defaultIcon,
        onClick,
        isSelected,
        style,
        size,
        pictureUrl,
    } = props;

    const [userImage, setUserImage] = useState<string>('');
    const [isLoadingUserDetails, setIsLoadingUserDetails] =
        useState<boolean>(true);
    const getSizing = (sizeProp) => {
        switch (sizeProp) {
            case UserAvatarButtonSize.LARGE:
                return {
                    buttonSize: { width: '64px', height: '49x' },
                    avatarSize: { width: '48px', height: '48px' },
                };
            case UserAvatarButtonSize.MEDIUM:
                return {
                    buttonSize: { width: '48px', height: '37px' },
                    avatarSize: { width: '32px', height: '32px' },
                };
            case UserAvatarButtonSize.SMALL:
            default:
                return {
                    buttonSize: { width: '36px', height: '28px' },
                    avatarSize: { width: '22px', height: '22px' },
                };
        }
    };
    const { buttonSize, avatarSize } = getSizing(size);

    const avatarLoadingHtml = (
        <div>
            <Skeleton
                variant="circular"
                width={avatarSize.width}
                height={avatarSize.height}
            />
        </div>
    );

    useEffect(() => {
        if (!_isNil(pictureUrl)) {
            setIsLoadingUserDetails(true);
            setUserImage(pictureUrl);
            setIsLoadingUserDetails(false);
        }
    }, [pictureUrl]);

    const userIcon =
        userImage !== '' ? (
            <img
                src={userImage}
                className={Styles.avatarIcon}
                style={avatarSize}
            />
        ) : (
            defaultIcon
        );

    return (
        <IconButton
            id={id}
            tooltip={tooltip}
            onClick={onClick}
            isSelected={isSelected}
            style={{ ...style, ...buttonSize }}
            icon={isLoadingUserDetails ? avatarLoadingHtml : userIcon}
        >
            {props.children}
        </IconButton>
    );
};

export default UserAvatarButton;
